import { useRecorderContext } from '../context/recorderContext';
import { SET_MEDIA_PERMISSION } from '../constants';

const useRequestMediaPermission = () => {
  const { mediaPermission, dispatch } = useRecorderContext();

  function requestMediaDevices(
    camera: boolean,
    mic: boolean,
    safemode = false
  ): Promise<MediaStream> {
    if (safemode) {
      return navigator.mediaDevices.getUserMedia({
        video: camera,
        audio: mic,
      });
    }
    return navigator.mediaDevices.getUserMedia({
      video: camera
        ? { width: { ideal: 1920 }, height: { ideal: 1080 } }
        : camera,
      audio: mic,
    });
  }

  const requestPermission = async (): Promise<undefined | Error> => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      // checks for input devices' availability.
      const micAvailable = !!devices.find(
        (d: MediaDeviceInfo) => d.kind === 'audioinput'
      );
      const cameraAvailable = !!devices.find(
        (d: MediaDeviceInfo) => d.kind === 'videoinput'
      );

      // check for permissions and ask for them if posible
      if (!mediaPermission && (cameraAvailable || micAvailable)) {
        await requestMediaDevices(cameraAvailable, micAvailable);
        dispatch({ type: SET_MEDIA_PERMISSION, payload: true });
      }

      // block camera option if no device availible
      // if (!cameraAvailable) {
      // }

      // TODO: implement this
      // dispatch({
      //   type: SET_GET_DEVICE_LIST,
      //   payload: true,
      // });
    } catch (error) {
      console.error('error getting user media permissions', error);
      try {
        await requestMediaDevices(true, true, true);
        dispatch({ type: SET_MEDIA_PERMISSION, payload: true });
      } catch (er) {
        return Promise.reject(er);
      }
    }
  };
  return requestPermission;
};
export default useRequestMediaPermission;
